export const TAB_STYLE = {
  fontSize: { xs: '0.9rem', sm: '1.3rem' },
  fontWeight: 700,
  '&.Mui-selected': {
    color: 'black',
  },
  color: 'gray',
  ':hover': {
    color: 'black',
  },
};

export const TABS = [
  {
    id: 1,
    value: null,
    label: 'All',
  },
  {
    id: 2,
    value: 'Non Academic',
    label: 'Non Academic',
  },
  {
    id: 3,
    value: 'Academic',
    label: 'Academic',
  },
];
